import type { FaireProductEntity } from "../../entity_types/product";

export const p_316fe66a: FaireProductEntity = {
  token: "p_316fe66a",
  type: "product",
  name: "Teakwood & Tobacco - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f10aa784d5b2b4bfe0864bea76f8f0e770994c539053ce384f8eba7c8ff2a8a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2acef9dd7c1b7e137865331588ed326533f2caf3714d41e0f3ca2b421e74d665.jpeg",
    "https://cdn.faire.com/fastly/aabbf0ee5033394b11327dcb0c85385be41f3dfa60b633044379ad7b5f1dae49.jpeg",
    "https://cdn.faire.com/fastly/13db08b780cc750e852f02c52e31fd039a2b76c0bcb7e9650aba1e57d090201c.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
  ],
  priceDollars: 5,
  description:
    'The one that started it all. Some call it the boyfriend scent, we call it the O.G. Notes of leather, teak, and orange.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:43.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
